require("!!C:\\project\\myproject\\node_modules\\script-loader\\addScript.js")(require("!!C:\\project\\myproject\\node_modules\\raw-loader\\index.js!C:\\project\\myproject\\node_modules\\babel-loader\\lib\\index.js!C:\\project\\myproject\\src\\vendor\\Blob.js"))


//////////////////
// WEBPACK FOOTER
// ./node_modules/script-loader!./src/vendor/Blob.js
// module id = FZkK
// module chunks = 1